export const globalStyles = `
    h1 {
      margin: 0;
    }
`;
